rjm.ui.ChartBuilderDimensionListView = rjm.ui.ChartBuilderBlockableView.extend(
  events:
    "change #categorySelect": "selectionChanged"
    "click .close": "removeCategory"

  initialize: (options) ->
    if not options.hasOwnProperty("chartModel") or not options.hasOwnProperty("viewState")
      throw "InvalidConstructorArgs - ChartBuilderSlicerListView"

    _.bindAll this, "selectionChanged", "removeCategory", "getAvailableCategories", "unblockCategorySelect", "render"
    #set incoming options
    @chartModel = options.chartModel
    @categorySet = @chartModel.getCurrentSeries().get("categorySet")
    @viewState = options.viewState

    @slicersFetched = false
        
    #bind model events
    @listenTo @chartModel.getCurrentSeries(), "change:trend", (series) =>
      @slicersFetched = false
      @stopListening @chartModel.getCurrentSeries().previous("trend")
      @listenTo series.get("trend"), "reset:slicers", @unblockCategorySelect
      @render()
    @listenTo @chartModel.getCurrentSeries(), "change", @render
    @listenTo @categorySet, "reset:categorySelectors", @render
    #we only want to unblock the category select dropdown once
    @listenTo @chartModel.getCurrentSeries().get("trend"), "reset:slicers", @unblockCategorySelect

    @nonTimeOptionsView = new rjm.ui.ChartBuilderNonTimeOptionsView
      chartModel: @chartModel

    @listenTo @chartModel, "change:api_conn_id", @block
    @listenTo @chartModel.getCurrentSeries(), "change:trend", @unblock
    return

  selectionChanged: (e) ->
    e.preventDefault()
    #we need to manually set the name for GA chart slicers (not available from the localStructure)
    if @chartModel.isGAChart()
      name = @chartModel.get('series').at(0).get('trend').get('slicers').getBySid(e.val)?.get('name')
    lsColumn = new rjm.model.LSColumn
      sid: e.val
      name: name
    categorySelector = new rjm.model.CategorySelector
      column: lsColumn
      values: []
      labels: []
    @categorySet.addCategory categorySelector
    @render()
    return false

  removeCategory: (e) ->
    e.preventDefault()
    index = @$(e.target).data("index")
    @categorySet.removeCategoryByIndex(index)
    @render()
    return false

  getAvailableCategories: ->
    availableCategories = [] #get all groupable slicers not already used as selectors
    @chartModel.getCurrentSeries().get("trend").get("slicers").each (model) =>

      # Create the category object
      category =
        id:model.get("sid")
        text: if _(model.get("name")).isUndefined() then "" else model.get("name")

      # Only add if it's groupable, not already added, or not already in our list
      if model.get("groupable") and not @categorySet.getCategoryBySid(model.get("sid")) and not _.findWhere(availableCategories, category)?
        availableCategories.push category

    return availableCategories

  unblockCategorySelect: ->
    @slicersFetched = true
    @addSelect2Dropdown()
    @$("#s2id_categorySelect").removeClass "blocked loading"
    return

  addSelect2Dropdown: ->
    @$("#categorySelect").select2
      placeholder: "Group by"
      data: @getAvailableCategories()
      containerCssClass: 'list-mode' # This is to give it that list style.
      width: 'resolve'
      closeOnSelect: false
    
    @$("#s2id_categorySelect").removeClass "blocked loading"
    return

  render: ->
    @$el.html ich.chartBuilderDimensionList()
    
    @categorySet.get("categorySelectors").each (category, index) =>
      view = new rjm.ui.ChartBuilderDimensionValuesView
        category: category
        categoryIndex: index
        chartModel: @chartModel
      @$("ul.categories").append view.el
      view.render()
      view.listenTo category, "remove", view.remove

    @addSelect2Dropdown()
    if @slicersFetched is false
      @$("#s2id_categorySelect").addClass "blocked loading"

    @nonTimeOptionsView.setElement(@$("#dimensionSorting")).render()

    return @
)
